import { IMultipleCounters } from '~/models/Job';
import {
  IBulkConfirmJobItem,
  IBulkConfirmPayload,
  IBulkConfirmRequest,
} from '../types/bulkConfirmTypes';
import { IJob } from '../types/jobsTypes';

function toBulkConfirmItem(job: IJob, candidateId: string, notes: string): IBulkConfirmJobItem {
  const offerCounter = job.multipleCounters?.find(
    ({ candidate }) => candidate.id === candidateId,
  ) as IMultipleCounters;
  return {
    counterCoverId: offerCounter.id,
    jobId: job.id,
    notes: notes || '',
    professionalId: candidateId,
  };
}

function toBulkConfirmRequest({
  jobs,
  selectedJobIds,
  candidateId,
  notes,
}: IBulkConfirmPayload): IBulkConfirmRequest {
  const confirmItems = selectedJobIds.map((jobId) => {
    const job = jobs.find((j) => j.id === jobId)!;
    return toBulkConfirmItem(job, candidateId, notes);
  });
  return { payload: confirmItems };
}

export const bulkConfirmAdapter = {
  toBulkConfirmRequest,
};
